export default "__VITE_ASSET__bf5a783f__"